import { motion } from "framer-motion";
import { lazy, Suspense } from "react";
import styled, { keyframes, ThemeProvider } from "styled-components";

import { DarkTheme, mediaQueries } from "./Themes";
import astronaut from "../assets/Images/spaceman.png";
import Loading from "../subComponents/Loading";
import { NavLink } from "react-router-dom";
import Seo from "./Seo";
import PageHeading from "./PageHeading";
import { pages, person } from "../data/site";
import {
  breadcrumbSchema,
  buildGraph,
  webpageSchema,
} from "../data/schema";
//Components
const SocialIcons = lazy(() => import("../subComponents/SocialIcons"));
const PowerButton = lazy(() => import("../subComponents/PowerButton"));
const LogoComponent = lazy(() => import("../subComponents/LogoComponent"));
const ParticlesComponent = lazy(() =>
  import("../subComponents/ParticleComponent")
);
const BigTitle = lazy(() => import("../subComponents/BigTitle"));

const Box = styled(motion.div)`
  background-color: ${(props) => props.theme.body};
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
`;

const float = keyframes`
0% { transform: translateY(-10px)         }
    50% { transform: translateY(15px) translateX(15px)        }
    100% { transform: translateY(-10px)         }
`;

const SpaceMan = styled(motion.div)`
  position: absolute;
  top: 10%;
  right: 5%;
  animation: ${float} 4s ease infinite;
  width: 20vw;
  img {
    width: 100%;
    height: auto;
  }
`;
const Main = styled(motion.div)`
  border: 2px solid ${(props) => props.theme.text};
  color: ${(props) => props.theme.text};
  padding: 2rem;
  width: 50vw;
  z-index: 3;
  line-height: 1.5;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: calc(0.5rem + 1vw);
  backdrop-filter: blur(4px);
  background: rgb(0 0 0 / 0%);
  position: absolute;
  left: calc(5rem + 5vw);
  top: calc(10% + 4rem + 5vw);
  box-sizing: border-box;
  max-height: calc(88% - 4rem - 5vw);

  font-family: "Ubuntu Mono", monospace;
  font-style: italic;
  overflow-y: auto;

  ${mediaQueries(40)`
          width: 65vw;
          font-size: calc(0.7rem + 0.8vw);
  `};
  ${mediaQueries(30)`
          width: auto;
          left: 4.5rem;
          right: 1rem;
          top: calc(10% + 6rem + 6vw);
          max-height: calc(86% - 6rem - 6vw);
          padding: 1.4rem;
          font-size: 0.95rem;
  `};
`;
const AboutPage = () => {
  const seo = pages.about;
  const schema = buildGraph([
    webpageSchema(seo),
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "About", path: seo.path },
    ]),
  ]);

  return (
    <ThemeProvider theme={DarkTheme}>
      <Seo
        title={seo.title}
        description={seo.description}
        path={seo.path}
        schema={schema}
      />
      <Suspense fallback={<Loading />}>
        <Box
          key="skills"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.5 } }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
        >
          <PageHeading>About Hareesh Rajendran</PageHeading>
          <LogoComponent theme="dark" />
          <PowerButton />
          <SocialIcons theme="dark" />
          <ParticlesComponent theme="dark" />

          <SpaceMan
            initial={{ right: "-20%", top: "100%" }}
            animate={{
              right: "5%",
              top: "10%",
              transition: { duration: 2, delay: 0.5 },
            }}
          >
            <img src={astronaut} alt="Illustration of Hareesh Rajendran as an astronaut" />
          </SpaceMan>
          <Main
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1, delay: 1 } }}
          >
            <div>
              {person.about}
              <br />
              <br />
              I work on AI Agents, Agentic AI, System Design, software
              engineering, developer tools, DSA and interview preparation. See{" "}
              <NavLink to="/experience" style={{ color: "inherit" }}>
                experience
              </NavLink>
              ,{" "}
              <NavLink to="/vanakkam-dsa" style={{ color: "inherit" }}>
                Vanakkam DSA
              </NavLink>{" "}
              and{" "}
              <NavLink to="/youtube" style={{ color: "inherit" }}>
                YouTube
              </NavLink>
              .
            </div>
          </Main>
          <BigTitle text="ABOUT" top="10%" left="5%" />
        </Box>
      </Suspense>
    </ThemeProvider>
  );
};

export default AboutPage;
